<template>
  <div
    class="ai-retry-button animate__animated animate__fadeIn"
    v-aha-emit-action="{user_input: userRetryMessage}"
    name="ai_retry_button"
    @click="$emit('clickOnAIRetryButton', 'Retry')"
  >
    <aha-icon
      name="reset"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      v-tooltip="$i18nPresenter.t('Retry')"
    />
    <div class="ai-retry-button-bg"></div>
  </div>
</template>

<script>
export default {
  props: {
    userRetryMessage: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.ai-retry-button {
  @apply mr-3 mb-3 cursor-pointer relative;
  &:hover, &:active {
    .ai-retry-button-bg {
      @apply opacity-100;
    }
  }
  .ai-retry-button-bg {
    @apply bg-primary-50 rounded-full absolute opacity-0;
    width: 32px;
    height: 32px;
    right: -7px;
    top: -4.5px;
    z-index: -1;
    transition:  0.2s ease-in-out;
  }
}
</style>
